export default __webpack_public_path__ + "static/media/student-work3.0ab3322b.jpeg";